import classNames from 'classnames';
import { Component } from 'react';

import './index.scss';

interface Props {
  className: string;
  loading: boolean;
  // Specific to the spinner color
  primary: boolean;
  secondary: boolean;
  success: boolean;
  warning: boolean;
  white: boolean;
  // Specific to Spinner size
  big: boolean;
  medium: boolean;
  smallMedium: boolean;
  small: boolean;
  // Specific to Spinner positionning
  center: boolean;
}

export class Spinner extends Component<Props> {
  public static demoProps = [
    { primary: true },
    { secondary: true, small: true },
    { warning: true, medium: true },
    { success: true, big: true },
  ];

  public static defaultProps = {
    className: '',
    loading: true,
    primary: false,
    secondary: true,
    success: false,
    warning: false,
    white: false,
    big: true,
    medium: false,
    smallMedium: false,
    small: false,
    center: false,
  };

  private strokeWidth() {
    const { small, medium, smallMedium } = this.props;
    if (small) {
      return '12';
    }
    if (medium || smallMedium) {
      return '7';
    }
    return '5';
  }

  public render() {
    const {
      className,
      loading,
      primary,
      secondary,
      success,
      warning,
      white,
      big,
      medium,
      small,
      smallMedium,
      center,
    } = this.props;

    if (!loading) {
      return null;
    }

    const isDefaultSize = !medium && !small;

    const containerClasses = {
      Spinner__container: true,
      'Spinner__container--center': center,
    };

    const spinnerClasses = {
      Spinner: true,
      'Spinner--big': isDefaultSize || big,
      'Spinner--medium': medium,
      'Spinner--small-medium': smallMedium,
      'Spinner--small': small,
    };

    const svgClasses = {
      Spinner__spinner: true,
      'Spinner__spinner--primary': primary,
      'Spinner__spinner--secondary': secondary,
      'Spinner__spinner--success': success,
      'Spinner__spinner--warning': warning,
      'Spinner__spinner--white': white,
      'Spinner__spinner--big': isDefaultSize || big,
      'Spinner__spinner--medium': medium,
      'Spinner__spinner--small-medium': smallMedium,
      'Spinner__spinner--small': small,
    };

    const spinner = (
      <span className={classNames(className, spinnerClasses)}>
        <svg
          className={classNames(svgClasses)}
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="Spinner__path"
            fill="none"
            strokeWidth={this.strokeWidth()}
            strokeLinecap="round"
            cx="50"
            cy="50"
            r="45"
          />
        </svg>
      </span>
    );

    if (center) {
      return <div className={classNames(containerClasses)}> {spinner} </div>;
    }

    return spinner;
  }
}
